import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon InviteCoWorkerIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const InviteCoWorkerIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 25 20">
      <g>
        <path d="M8.57,11.04c-2.93,0-5.32-2.39-5.32-5.32S5.64,0.4,8.57,0.4s5.32,2.39,5.32,5.32S11.51,11.04,8.57,11.04z  M8.57,1.89c-2.11,0-3.82,1.71-3.82,3.82s1.71,3.82,3.82,3.82s3.82-1.71,3.82-3.82S10.68,1.89,8.57,1.89z" />
      </g>
      <g>
        <path d="M16.66,19.51H0.49v-3.8c0-3.2,2.5-5.7,5.7-5.7h4.76c3.14,0,5.7,2.56,5.7,5.7v3.8H16.66z M1.99,18.01h13.17 v-2.3c0-2.32-1.89-4.2-4.2-4.2H6.19c-2.36,0-4.2,1.85-4.2,4.2C1.99,15.71,1.99,18.01,1.99,18.01z" />
      </g>
      <g>
        <path d="M24.29,6.94h-7.62c-0.41,0-0.75-0.34-0.75-0.75s0.34-0.75,0.75-0.75h7.62c0.41,0,0.75,0.34,0.75,0.75 S24.7,6.94,24.29,6.94z" />
      </g>
      <g>
        <path d="M20.48,10.75c-0.41,0-0.75-0.34-0.75-0.75V2.38c0-0.41,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75V10 C21.23,10.41,20.89,10.75,20.48,10.75z" />
      </g>
    </Icon>
  )
}
export default InviteCoWorkerIcon
